/* Display-only price estimates on product cards. Checkout still charges in GHS. */
(function () {
  if (window.cedizCardEstimates) return;
  window.cedizCardEstimates = true;

  var SUPPORTED = ['USD','GBP','EUR','CAD','AUD','NGN','AED','NZD','JPY','CNY','MYR','SGD','PHP','MXN','PLN','SEK'];
  var BASE = (document.documentElement.dataset.shopCurrency || 'GHS');
  var rates = null;

  function guessCurrency() {
    var euro = ['AT','BE','CY','DE','EE','ES','FI','FR','GR','HR','IE','IT','LT','LU','LV','MT','NL','PT','SI','SK'];
    var map = { US: 'USD', GB: 'GBP', CA: 'CAD', AU: 'AUD', NG: 'NGN', AE: 'AED', NZ: 'NZD', JP: 'JPY', CN: 'CNY', MY: 'MYR', SG: 'SGD', PH: 'PHP', MX: 'MXN', PL: 'PLN', SE: 'SEK', GH: 'GHS' };
    var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})\b/.exec(langs[i]);
      if (!m) continue;
      var cc = m[1].toUpperCase();
      if (euro.indexOf(cc) > -1) return 'EUR';
      if (map[cc]) return map[cc];
    }
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    if (tz === 'Africa/Accra') return 'GHS';
    if (tz.indexOf('America/') === 0 && tz.indexOf('Mexico') === -1) return 'USD';
    if (tz === 'Europe/London') return 'GBP';
    if (tz === 'Africa/Lagos') return 'NGN';
    if (tz === 'Asia/Dubai') return 'AED';
    if (tz.indexOf('Australia/') === 0) return 'AUD';
    if (tz.indexOf('Europe/') === 0) return 'EUR';
    return null;
  }

  function currentCurrency() {
    var saved = null;
    try { saved = localStorage.getItem('cediz-currency'); } catch (e) {}
    if (saved && SUPPORTED.indexOf(saved) > -1) return saved;
    var guessed = guessCurrency();
    if (guessed === BASE) return null; // local shoppers already see their own currency
    if (guessed && SUPPORTED.indexOf(guessed) > -1) return guessed;
    return 'USD';
  }

  function loadRates() {
    var key = 'cediz-rates-' + BASE;
    try {
      var cached = JSON.parse(localStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < 12 * 60 * 60 * 1000) {
        rates = cached.rates;
        return Promise.resolve();
      }
    } catch (e) {}
    return fetch('https://open.er-api.com/v6/latest/' + BASE)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.rates) {
          rates = data.rates;
          try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), rates: data.rates })); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  function format(amount, code) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
    } catch (e) {
      return code + ' ' + amount.toFixed(2);
    }
  }

  function renderAll() {
    var code = currentCurrency();
    var els = document.querySelectorAll('.price-estimate[data-price]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var next = '';
      var cents = parseInt(el.dataset.price, 10) || 0;
      if (code && rates && rates[code]) next = '≈ ' + format((cents / 100) * rates[code], code);
      if (el.textContent !== next) el.textContent = next;
    }
  }

  var pending = null;
  function scheduleRender() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; renderAll(); }, 50);
  }

  function init() {
    loadRates().then(function () {
      renderAll();
      // Cards loaded later (filters, sorting, recommendations, quick add) get estimates too.
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) { scheduleRender(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    });
    document.addEventListener('cediz:currency-change', renderAll);
    window.addEventListener('storage', function (e) { if (e.key === 'cediz-currency') renderAll(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
